import React, { useState } from "react";
import axios from 'axios'
import {useNavigate} from "react-router-dom";
import style from "./index.module.scss";
import {path} from "../../utils/const";
import Spinner from "../Spinner"

const MedicalListToggle = (props)=> {

  const {content,toggleModal, isDocInformation, loading} =props


  return (
  <div className={style.modal}>
      <Spinner color="#DF7467" isLoading={loading} />
    <div>
      <p className={style.message}>{content}</p>
      <div className={style.toggelButton}>
        <button className={style.cancelButton} onClick={toggleModal} disabled={loading}>
          {isDocInformation?"No":"Ok"}
        </button>
      </div>
    </div>
  </div>
  );
}

export default MedicalListToggle;
